import { AuthModule, LogLevel, StsConfigHttpLoader, StsConfigLoader } from "angular-auth-oidc-client";
import { map, shareReplay } from "rxjs/operators";

import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { NWDUserConfig } from "../../helpers/types";
import { ENV, apiUrl } from "../app.runtime";
import { OidcAuthenticationConfig } from "./types";

const LOGLEVEL = ENV.DEBUG_OAUTH ? LogLevel.Debug : LogLevel.Error;

export const httpLoaderFactory = (httpClient: HttpClient) => {
  const configObservable$ = httpClient.get<NWDUserConfig>(apiUrl("user/config")).pipe(shareReplay(1));
  const config$ = configObservable$.pipe(
    map((customConfig: NWDUserConfig) => ({
      configId: OidcAuthenticationConfig.Default,
      authority: customConfig.issuer,
      redirectUrl: `${window.location.origin}/oauth2/callback`,
      clientId: customConfig.clientId,
      responseType: "code",
      scope: "openid profile email", // scope 'offline' provides a refresh token
      postLogoutRedirectUri: `${window.location.origin}/`, // Redirect URL after logout
      // startCheckSession: customConfig.start_checksession,
      silentRenew: true,
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      // postLoginRoute: customConfig.startup_route,
      forbiddenRoute: `${window.location.origin}/forbidden`,
      unauthorizedRoute: `${window.location.origin}/unauthorized`,
      logLevel: LOGLEVEL,
      // default value for this offset is 120. Increase to 600
      // to prevent issues where the client clock is set a few minutes in the
      // future.
      // A clock too far in the future makes the library reject the ID token.
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      historyCleanupOff: true,
      checkRedirectUrlWhenCheckingIfIsCallback: false,
      secureRoutes: customConfig.oauthEnabled ? [apiUrl(""), ENV.DOMAINS_API] : [],
      // autoUserInfo: false,
    })),
  );
  const configStepup$ = configObservable$.pipe(
    map((customConfig: NWDUserConfig) => ({
      configId: OidcAuthenticationConfig.SelfService,
      authority: customConfig.issuer,
      redirectUrl: `${window.location.origin}/oauth2/callback`,
      autoCleanStateAfterAuthentication: false, // don't clean state, so we can redirect the user afterwards.
      clientId: customConfig.clientId,
      responseType: "code",
      scope: "openid profile email", // scope 'offline' provides a refresh token
      postLogoutRedirectUri: `${window.location.origin}/`, // Redirect URL after logout
      // startCheckSession: customConfig.start_checksession,
      silentRenew: false,
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      // postLoginRoute: customConfig.startup_route,
      forbiddenRoute: `${window.location.origin}/forbidden`,
      unauthorizedRoute: `${window.location.origin}/unauthorized`,
      logLevel: LOGLEVEL,
      // default value for this offset is 120. Increase to 600
      // to prevent issues where the client clock is set a few minutes in the
      // future.
      // A clock too far in the future makes the library reject the ID token.
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      historyCleanupOff: true,
      checkRedirectUrlWhenCheckingIfIsCallback: false,
      secureRoutes: customConfig.oauthEnabled ? [apiUrl(""), ENV.DOMAINS_API] : [],
      customParamsAuthRequest: {
        acr_values: customConfig.loa,
      },
      // autoUserInfo: false,
    })),
  );

  return new StsConfigHttpLoader([config$, configStepup$]);
};

@NgModule({
  imports: [
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthHttpConfigModule {}
